'use client'

import { useState } from 'react';
import { Header, Form, FieldCells, FieldCell, Field, FieldLabel, Button } from '@ginieapp/ginie-ui';
import styles from './hrx.module.scss'
import Image from "next/image";
import ApiUtils from '@/utils/ApiUtils';
import { useRouter } from 'next/navigation';

export default function LoginScreen(props) {

  const router = useRouter()

  const urls = {
    login: "/t2/v1/users/login",
    forgot_password: "/t2/v1/users/send_otp",
    reset_password: "/t2/v1/users/change_password",
    otp: "/t2/v1/users/confirm_otp",
  }

  const [form,setForm] = useState({})
  const [error, setError] = useState(null)
  const [mode, setMode] = useState('login') // login | forgot_password  

  const onChange = (e) => {
    let data = Object.assign({}, form)
    data[e.target.name] = e.target.value
    setForm(data)
  }

  const submit = (e) => {
    if (e) e.preventDefault()
    if (mode == 'reset_password') {
      if (!form.password || !form.confirm_password) {
        setError("Please enter your password")
        return
      }
      if (form.password != form.confirm_password) {
        setError("Passwords don't match")
        return
      }
    }
    if (mode == 'login') {
      if (!form.email || !form.password) {
        setError("Please enter your email and password")
        return
      }
    }
    if (mode == 'forgot_password') {
      if (!form.email) {
        setError("Please enter your email")
        return
      }
    }
    if (mode == 'otp') {
      if (!form.otp) {
        setError("Please enter the one-time password sent to your email")
        return
      }
    }
    setError(null)
    ApiUtils.postRequest(urls[mode], form)
    .then(data => {
      if (mode == 'login') {
        if (data.error) {
          setError(data.error)
          return
        }
        if (props.onLogin) {
          props.onLogin(e)
        } else {
          if (window.location.hostname.includes("dealerx")) {
            router.push("/dealer/automation")
          } else {
            if (data.user?.role == 30 || data.user?.role == 999) {
              router.push("/amp/dashboard")
            } else {
              router.push("/pipeline")
            }
          }
        }
      }
      if (mode == 'forgot_password') {
        setForm({ otp_id: data.otp_id })
        setMode('otp')
      }
      if (mode == 'otp') {
        if (data.email) {
          setForm(data)
          setMode('reset_password')
        } else {
          setError(data.error)
        }
      }
      if (mode == 'otp') {
        if (data.email) {
          setForm(data)
          setMode('reset_password')
        } else {
          setError(data.error)
        }
      }
      if (mode == 'reset_password') {
        if (data.email) {
          setForm(data)
          setMode('login')
        } else {
          setError(data.error)
        }
      }
    })
  }

  return <div className='page'>
    <Header className={styles.header}>
      <div className={styles.header_logo}>
        <img src={process.env.NEXT_PUBLIC_CDN + "/images/highroadx-logo.png"}></img>
      </div>
      <span></span>
      <div className={styles.header_dlogo}>
        <img src={process.env.NEXT_PUBLIC_CDN + "/images/dealerx-logo.svg"}></img>
      </div>
    </Header>
    <main className='flex-centered'>
      <Image src={process.env.NEXT_PUBLIC_CDN + "/images/home-bg.svg"} alt={'Base Screen Background'} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "cover" }} priority={true} sizes={'1024x1024'}></Image>
      <div className={styles.form}>
        <Form id="login_form" name="Login Form" onSubmit={e => submit(e)}>
          <FieldCells>
            { error &&
            <FieldCell>
              <div className={'form-error'}>{error}</div>
            </FieldCell>}
            { (mode === 'login' || mode === 'forgot_password') &&
            <FieldCell>
              {/* <FieldLabel for={'username'} className={styles.label}>Username</FieldLabel> */}
              <Field type="text" label="Email" name="email" value={form.username || ''} placeholder="Email" theme="trn-line" onChange={e => onChange(e)}></Field>
            </FieldCell>
            }
            { mode === 'otp' &&
            <>
            <FieldCell>
              <span className='text-white'>We have emailed you a one-time code to reset your password. Please enter it below.</span>
            </FieldCell>
            <FieldCell>
              {/* <FieldLabel for={'username'} className={styles.label}>Username</FieldLabel> */}
              <Field type="text" label="One-time password" name="otp" value={form.otp || ''} placeholder="One-time password" theme="trn-line" onChange={e => onChange(e)}></Field>
            </FieldCell>
            </>
            }
            { mode === 'reset_password' &&
            <>
            <FieldCell>
              <Field type="password" label="New Password" name="password" value={form.password || ''} placeholder="New Password" theme="trn-line" onChange={e => onChange(e)}></Field>
            </FieldCell>
            <FieldCell>
              <Field type="password" label="Confirm Password" name="confirm_password" value={form.confirm_password || ''} placeholder="Confirm Password" theme="trn-line" onChange={e => onChange(e)}></Field>
            </FieldCell>
            </>
            }
            { mode == 'login' &&
            <FieldCell>
              {/* <FieldLabel for={'password'} className={styles.label}>Password</FieldLabel> */}
              <Field type="password" label="Password" name="password" value={form.password || ''} placeholder="Password" theme="trn-line" onChange={e => onChange(e)}></Field>
            </FieldCell>}
            <FieldCell>
              <Button theme={['primary']}>{ mode == 'login' ? 'Login' : mode == 'forgot_password' ? 'Reset Password' : mode == 'reset_password' ? 'Reset' : 'Continue' }</Button>
            </FieldCell>
            { mode == 'login' &&
            <FieldCell>
              <Button type="button" theme={['plain']} style={{ color: '#FFFFFF'}} onClick={() => setMode('forgot_password')}>Forgot Password?</Button>
            </FieldCell>
            }
          </FieldCells>
        </Form>
      </div>
    </main>
  </div>


}